// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: var(--semi-color-bg-0);
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

/* body::-webkit-scrollbar {
  display: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.main-content {
  padding: 4px;
}

.small-icon .icon {
  font-size: 1em !important;
}

.custom-footer {
  font-size: 1.1em;
}

@media only screen and (max-width: 600px) {
  .hide-on-mobile {
    display: none !important;
  }
} */

.semi-card {
  border-radius: 20px !important;
}

.semi-button,
.semi-input-wrapper {
  border-radius: 8px !important;
}

@media only screen and (max-width: 767px) {
  /*.semi-navigation-sub-wrap .semi-navigation-sub-title, .semi-navigation-item {*/
  /*  padding: 0 0;*/
  /*}*/
  .topnav .semi-navigation-list-wrapper {
    max-width: calc(55vw - 20px);
    overflow-x: auto;
    scrollbar-width: none;
  }
  #root > section > header > section > div > div > div > div.semi-navigation-footer > div > a > li {
    padding: 0 0;
  }
  #root > section > header > section > div > div > div > div.semi-navigation-header-list-outer > div.semi-navigation-list-wrapper > ul > div > a > li {
    padding: 0 5px;
  }
  #root > section > header > section > div > div > div > div.semi-navigation-footer > div:nth-child(1) > a > li {
    padding: 0 5px;
  }
  .semi-navigation-footer {
    padding-left: 0;
    padding-right: 0;
  }
  .semi-table-tbody,
  .semi-table-row,
  .semi-table-row-cell {
    display: block !important;
    width: auto !important;
    padding: 2px !important;
  }
  .semi-table-row-cell {
    border-bottom: 0 !important;
  }
  .semi-table-tbody > .semi-table-row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .semi-space {
    /*display: block!important;*/
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 3px;
    column-gap: 10px;
  }

  .semi-navigation-horizontal .semi-navigation-header {
    margin-right: 0;
  }
}

/* 启用响应式布局相关样式 */
@media screen and (max-width: 768px) {
  .semi-card {
    border-radius: 12px !important;
  }
  
  .semi-button,
  .semi-input-wrapper {
    border-radius: 6px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;;AAEH;EACE,8BAA8B;AAChC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,gFAAgF;EAChF,kBAAkB;EAClB,IAAI;EACJ;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;EACvB;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;;;IAGE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,8BAA8B;EAChC;;EAEA;;IAEE,6BAA6B;EAC/B;AACF","sourcesContent":["body {\n  background-color: var(--semi-color-bg-0);\n  margin: 0;\n  padding: 0;\n  min-height: 100vh;\n}\n\n/* body::-webkit-scrollbar {\n  display: none;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.main-content {\n  padding: 4px;\n}\n\n.small-icon .icon {\n  font-size: 1em !important;\n}\n\n.custom-footer {\n  font-size: 1.1em;\n}\n\n@media only screen and (max-width: 600px) {\n  .hide-on-mobile {\n    display: none !important;\n  }\n} */\n\n.semi-card {\n  border-radius: 20px !important;\n}\n\n.semi-button,\n.semi-input-wrapper {\n  border-radius: 8px !important;\n}\n\n@media only screen and (max-width: 767px) {\n  /*.semi-navigation-sub-wrap .semi-navigation-sub-title, .semi-navigation-item {*/\n  /*  padding: 0 0;*/\n  /*}*/\n  .topnav .semi-navigation-list-wrapper {\n    max-width: calc(55vw - 20px);\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n  #root > section > header > section > div > div > div > div.semi-navigation-footer > div > a > li {\n    padding: 0 0;\n  }\n  #root > section > header > section > div > div > div > div.semi-navigation-header-list-outer > div.semi-navigation-list-wrapper > ul > div > a > li {\n    padding: 0 5px;\n  }\n  #root > section > header > section > div > div > div > div.semi-navigation-footer > div:nth-child(1) > a > li {\n    padding: 0 5px;\n  }\n  .semi-navigation-footer {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .semi-table-tbody,\n  .semi-table-row,\n  .semi-table-row-cell {\n    display: block !important;\n    width: auto !important;\n    padding: 2px !important;\n  }\n  .semi-table-row-cell {\n    border-bottom: 0 !important;\n  }\n  .semi-table-tbody > .semi-table-row {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  }\n  .semi-space {\n    /*display: block!important;*/\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    row-gap: 3px;\n    column-gap: 10px;\n  }\n\n  .semi-navigation-horizontal .semi-navigation-header {\n    margin-right: 0;\n  }\n}\n\n/* 启用响应式布局相关样式 */\n@media screen and (max-width: 768px) {\n  .semi-card {\n    border-radius: 12px !important;\n  }\n  \n  .semi-button,\n  .semi-input-wrapper {\n    border-radius: 6px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
